export enum SellerType {
    UNKNOWN = 0,
    OWNER = 1,
    AGENT = 2,
    AGENCY = 3,
    DEVELOPER = 4,
    PIT = 5
}
